import { Link } from 'react-router-dom';

import { Icon, Typography } from '@/ui';

import type { HomeSessionAssetRow } from './sessionReflectionHomeUtils';
import type { FC } from 'react';

import {
  buildMemberMomentsAnalyticsProperties,
  MEMBER_MOMENTS_EVENTS,
  momentsAnalytics,
} from '@/services/momentsAnalytics';

interface SessionReflectionRowProps {
  row: HomeSessionAssetRow;
}

const highlightLabel = (count: number) =>
  `${count} ${count === 1 ? 'Highlight' : 'Highlights'}`;

const captionFor = (row: HomeSessionAssetRow) =>
  [
    row.contextLabel,
    row.savedHighlightCount > 0
      ? highlightLabel(row.savedHighlightCount)
      : undefined,
  ]
    .filter(Boolean)
    .join(' · ');

const SessionReflectionRow: FC<SessionReflectionRowProps> = ({ row }) => {
  const caption = captionFor(row);

  return (
    <Link
      className="flex items-center gap-4 border-0 border-t border-solid border-cement-200 px-8 py-5 no-underline transition hover:bg-sunny-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-sage-500"
      to={row.href}
      onClick={() => {
        momentsAnalytics.track(
          MEMBER_MOMENTS_EVENTS.clickedHomeReflection,
          buildMemberMomentsAnalyticsProperties({
            artifactId: row.id,
            destination: row.href,
            route: window.location.pathname,
            sessionId: row.sessionId,
            surface: 'home',
          }),
        );
      }}
    >
      <Typography className="w-[72px] shrink-0 text-cement-400" variant="body1">
        {row.dateLabel}
      </Typography>
      <div className="min-w-0 flex-1">
        <Typography className="line-clamp-1 text-cement-500" variant="body1">
          {row.snippet}
        </Typography>
        {caption ? (
          <Typography className="mt-1 block text-cement-400" variant="caption">
            {caption}
          </Typography>
        ) : null}
      </div>
      <Icon className="shrink-0 text-cement-300" aria-hidden>
        chevron_right
      </Icon>
    </Link>
  );
};

export default SessionReflectionRow;
